import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { RecepcionVehiculoService } from '../../../modulos/taller/componentes/recepcion-vehiculo/recepcion-vehiculo.service';
import { GlobalsService } from '../../../../core/services/globals.service';

@Component({
    selector: 'app-modal-esa',
    templateUrl: './modal-esa.component.html',
    styleUrls: ['./modal-esa.component.scss']
})


export class ModalEsaComponent implements OnInit {

    @Output() modalCloseEsa = new EventEmitter<any>();
    @Input() Vin: string;
    @Input() Plate: string;
    @Input() BrandCode: string;
    @Input() Description: string;
    @Input() PlateRegistrationDate: string;

    formEsa: FormGroup;
    error: string;
    code: string;
    GetAllVehicles: any[];
    Elements: any[];
    hasChanges: boolean;

    constructor(
        private _recepcionVehiculoService: RecepcionVehiculoService,
        private _globalService: GlobalsService,
        private toastr: ToastrService
    ) {
        this.GetAllVehicles = [];
        this.hasChanges = false;
        this.Elements = [
            {
                "DmsValue": "",
                "EsaValue": "",
                "IsSync": true,
                "Name": "Model"
            },
            {
                "DmsValue": "",
                "EsaValue": "",
                "IsSync": true,
                "Name": "Description"
            },
            {
                "DmsValue": "",
                "EsaValue": "",
                "IsSync": true,
                "Name": "Plate"
            },
            {
                "DmsValue": "",
                "EsaValue": "",
                "IsSync": true,
                "Name": "PlateRegistrationDate"
            }
        ]
    }
    ngOnInit() {
        this.crearForm();
        this.vehicles();
        //solo validamos al entrar con los datos
        this.searchVehicleESA();
    }

    crearForm() {
        this.formEsa = new FormGroup({
            Plate: new FormControl(this.Plate, [Validators.required]),
            PlateCheck: new FormControl(false),
            Vin: new FormControl({ value: this.Vin, disabled: true }),
            Model: new FormControl(null, [Validators.required]),
            ModelCheck: new FormControl(false),
            Description: new FormControl(this.Description, [Validators.required]),
            DescriptionCheck: new FormControl(false),
            PlateRegistrationDate: new FormControl(this._globalService.getDateFormat(this.PlateRegistrationDate), { validators: this.dateValidator(), updateOn: 'blur' }),
            PlateRegistrationDateCheck: new FormControl(false),
        });
    }

    //Servicio que devuelve las marcas de los coches
    vehicles() {
        this._recepcionVehiculoService.getDataAllVehicles().subscribe((data: any) => {
            const auxdata = data.Response.Content;
            if (auxdata) {
                this.GetAllVehicles = auxdata;
                for (let i = 0; i < this.GetAllVehicles.length; i++) {
                    if (this.GetAllVehicles[i].BrandCode === this.BrandCode) {
                        this.formEsa.get('Model').setValue(this.GetAllVehicles[i]);
                        break;
                    }
                }
            }
        });
    }

    updateESA() {
        for (let i = 0; i < this.Elements.length; i++) {
            if (this.Elements[i].Name === 'Model') {
                this.Elements[i].EsaValue = this.formEsa.get('Model').value.BrandCode;
            } else if (this.Elements[i].Name === 'PlateRegistrationDate') {
                this.Elements[i].EsaValue = this._globalService.getDateFormatForServer(this.formEsa.get('PlateRegistrationDate').value);
            } else {
                this.Elements[i].EsaValue = this.formEsa.get(this.Elements[i].Name).value;
            }
            this.Elements[i].DmsValue = ''
        }
        let _URL_ = `${environment.ENTORNO}Services/Workshop/EsaService.svc/UpdateDmsVehicle`;
        let params = {
            vin: this.Vin,
            updatingElements: this.Elements
        }
        this._recepcionVehiculoService.getAll(_URL_, params).subscribe(resp => {
            this.closeModal('modalEsa', true);
        });
    }

    closeModal(result: any, datos: boolean) {
        if (result && datos) {
            const datosForm = this.formEsa.getRawValue();
            const params = {
                'pantalla': result,
                'datosForm': datosForm
            };

            this.modalCloseEsa.emit(params);
        } else {
            const params = {
                'pantalla': result,
                'datosForm': null
            };
            this.modalCloseEsa.emit(params);
        }
    }

    dateValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            if (Object.prototype.toString.call(control.value) === "[object Date]") {
                if (!isNaN(control.value.getTime())) {
                    return null;
                }
            };
            return { 'PlateRegistrationDate': true };
        }
    }

    searchVehicleESA() {
        let _URL_ = `${environment.ENTORNO}Services/Workshop/EsaService.svc/GetVehicleSync`;
        let params = {
            request: {
                Vin: this.Vin
            }
        }
        this._recepcionVehiculoService.getAll(_URL_, params).subscribe(resp => {
            let TempElements = resp['Response'].Elements;
            for (let i = 0; i < TempElements.length; i++) {
                for (let j = 0; j < this.Elements.length; j++) {
                    if (this.Elements[j].Name === TempElements[i].Name) {
                        this.Elements.splice(j, 1);
                        let vehicleFound = false;
                        if (TempElements[i].Name === 'Model') {
                            for (let k = 0; k < this.GetAllVehicles.length; k++) {
                                if (this.GetAllVehicles[k].BrandCode === TempElements[i].EsaValue) {
                                    this.formEsa.get('Model').setValue(this.GetAllVehicles[k]);
                                    vehicleFound = true;
                                    break;
                                }
                            }
                            if (!vehicleFound) {
                                this.formEsa.get('Model').setValue(this.GetAllVehicles[1]);
                            }
                        } else if (TempElements[i].Name === 'PlateRegistrationDate') {
                            let newDate = this._globalService.getDateFormat(TempElements[i].EsaValue);
                            this.formEsa.get('PlateRegistrationDate').setValue(newDate);
                            if (Object.prototype.toString.call(newDate) !== "[object Date]" || isNaN(newDate.getTime())) {
                                this.formEsa.get('PlateRegistrationDate').setErrors({ 'PlateRegistrationDate': true });
                            }
                        } else {
                            this.formEsa.get(TempElements[i].Name).setValue(TempElements[i].EsaValue, { emitEvent: false });
                        }
                        if (!TempElements[i].IsSync) {
                            this.hasChanges = true;
                            this.formEsa.get(TempElements[i].Name + 'Check').setValue(true, { emitEvent: false });
                        }
                        break;
                    }
                }
            }
            this.Elements = this.Elements.concat(TempElements);
        });
    }

}

